module.exports = __webpack_public_path__ + "static/media/selectedConnection.cb185229.svg";